import addEntity from 'owa-controls-findpeople-feedback-manager/lib/actions/addEntity';
import FindControlViewState, {
    FindResultType,
} from 'owa-recipient-types/lib/types/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import EntityAddSource from 'owa-service/lib/contract/EntityAddSource';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import getDisplayName from './getDisplayName';
import shouldUse3SPeopleSuggestions from 'owa-recipient-suggestions/lib/util/shouldUse3SPeopleSuggestions';
import { lazyLogSearchEntityActions } from 'owa-search-instrumentation';
import SubstrateSearchScenario from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';
import sessionStore from 'owa-session-store/lib/store/store';

/**
 * Adds a find people entity feedback for a persona picked from the find control
 */
export default function addFindPeopleEntityFromResults(
    recipientWellViewState: FindControlViewState,
    persona: FindRecipientPersonaType,
    findResultIndex: number,
    scenario: SubstrateSearchScenario
) {
    if (persona) {
        let displayName = getDisplayName(persona);
        let extraData = {
            TargetEntityType: persona.PersonaTypeString,
            ReferenceId: persona.ReferenceId,
        };

        if (!isNullOrWhiteSpace(displayName)) {
            let recipientEmailAddressesAndPositionIndexesDictionary: {
                [displayName: string]: number;
            } = {};
            recipientEmailAddressesAndPositionIndexesDictionary[displayName] = findResultIndex;

            addEntity(
                recipientWellViewState.findPeopleFeedbackManager,
                getEntityAddSource(
                    recipientWellViewState.findResultType,
                    recipientWellViewState.numberOfCacheResults,
                    findResultIndex
                ),
                recipientWellViewState.queryString,
                displayName,
                persona.TransactionId,
                recipientEmailAddressesAndPositionIndexesDictionary,
                extraData
            );
        }

        if (shouldUse3SPeopleSuggestions()) {
            const userId: string = sessionStore.userConfiguration.SessionSettings.UserPuid;
            const tenantId: string = sessionStore.userConfiguration.SessionSettings.TenantGuid;

            lazyLogSearchEntityActions.importAndExecute(
                scenario,
                userId,
                tenantId,
                persona.LogicalId, // CorrelationId from the outgoing request.
                persona.TransactionId, // traceId from the incoming suggestions.
                persona.ReferenceId, // ReferenceId, comes in with suggestions.
                'EntityClicked' // EventType
            );
        }
    }
}

function getEntityAddSource(
    findResultType: FindResultType,
    numberOfCacheResults: number,
    findResultIndex: number
): EntityAddSource {
    switch (findResultType) {
        case FindResultType.Cache:
            return EntityAddSource.LocalCache;
        case FindResultType.FindPeople:
            return EntityAddSource.EntityRelevanceApi;
        case FindResultType.SearchDirectory:
            return EntityAddSource.ActiveDirectory;
        case FindResultType.MixedCacheLive:
            return findResultIndex < numberOfCacheResults
                ? EntityAddSource.LocalCache
                : EntityAddSource.EntityRelevanceApi;
        default:
            return EntityAddSource.Other;
    }
}
